import React from "react";
import * as Script from "../../dumb/script/Script";
// import { isArray } from "util";

export class ScriptContainer extends React.Component<any,any> {

    constructor(props:any) {

        super(props);
        this.state = { urls: Array<Object>() }
        // this.state = { urls : Object() }
    }

    componentDidMount = () => {
        
        let myHtmlTags = document.getElementsByTagName("html");
        
        for (let i = 0; i < myHtmlTags.length; i++) {

            //it does work - get my html tag
            myHtmlTags[i].className = "";
        }

        // console.log('ScriptContainer mounted')
        setTimeout(()=>{
            fetch("./api/jsonFiles/scriptUrlsIds.json")
                .then(response => response.json())
                .then(data => {

                    this.setState({ urls: data.urls })
                    // console.log(this.state.urls)Script.FriendStatus("pippo")
                    Script.Script.urls(this.state.urls)
                })
        },500)
        
    }

    render = () => null
}